export default "__VITE_ASSET__CvNPEYui__"